import { Component, Input, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'sbnb-icon-homeaway',
  templateUrl: './icon-homeaway.component.html',
  styles: [
    `
      @import 'variables';
      :host ::ng-deep .icon-platform-muted svg path {
        fill: $smoke-darker;
      }
    `,
  ],
})
export class IconHomeawayComponent implements OnInit {
  @Input() size = 16;
  @Input() white = false;
  @Input() muted = false;

  constructor() {}

  ngOnInit() {}
}
